<template>
	<div class="teaser-form">
		<div class="teaser-form__direction">
			<InputGroup
				:title="'Material Publicitário'"
				:customClass="'full'"
				:id="'offerTeaser'"
				:ref="'offerTeaser'"
				:placeholder="'Material Publicitário.pdf'"
				:isFile="true"
				:isTeaser="true"
				@clearTeaser="clearTeaser"
				v-model="offer.teaserPdfUrl"
			/>
		</div>
		<div class="teaser-form__direction">
			<InputGroup
				:title="'Vídeo'"
				:id="'offer_video'"
				:placeholder="'https://www.youtube.com/videodooriginador'"
				:isLink="true"
				v-model="offer.videoUrl"
			/>
			<MultiselectGroup
				:isWeb="isWeb"
				:label="'Tipo de Vídeo:'"
				:type="'videoType'"
				:options="videoOptions"
				:placeholder="'Tipo de Vídeo'"
				:alert="false"
				ref="videoType"
				@changeMultiselectInput="changeMultiselectInput"
			/>
		</div>
	</div>
</template>

<script>
import InputGroup from '@/components/modules/Offer/OfferDetail/InputGroup/InputGroup.vue';
import MultiselectGroup from '@/components/modules/Offer/OfferDetail/MultiselectGroup/MultiselectGroup.vue';

export default {
	name: 'OfferTeaserForm',
	components: {
		InputGroup,
		MultiselectGroup,
	},
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		offer: {
			teaserPdfUrl: null,
			videoUrl: null,
			videoType: null,
		},
	}),
	methods: {
		changeMultiselectInput(param) {
			if (param.type == 'videoType') {
				this.offer.videoType = param.value.id;
			}
		},
		clearTeaser() {
			this.offer.teaserPdfUrl = null;
		},
		loadOfferDetails(selectedOffer) {
			this.loadVideoInputs(selectedOffer);
			this.loadTeaserInputs(selectedOffer);
		},
		loadTeaserInputs(selectedOffer) {
			const teaserData = {
				teaserPdfUrl: selectedOffer.teaserPdfUrl,
			};

			Object.assign(this.offer, teaserData);

			if (selectedOffer.teaserPdfUrl) {
				const splitedTeaserName = selectedOffer.teaserPdfUrl.split('/');
				this.$refs.offerTeaser.setFileName(splitedTeaserName[splitedTeaserName.length - 1]);
			}
		},
		loadVideoInputs(selectedOffer) {
			const videoData = {
				videoType: selectedOffer.videoType,
				videoUrl: selectedOffer.videoUrl,
			};

			Object.assign(this.offer, videoData);

			if (selectedOffer.videoType == 'youtube') {
				this.$refs.videoType.setValue(this.videoOptions[0]);
			} else if (selectedOffer.videoType == 'vimeo') {
				this.$refs.videoType.setValue(this.videoOptions[1]);
			}
		},
		getTeaserFile() {
			return this.$refs.offerTeaser.getFile();
		},
		getTeaserData() {
			return this.offer;
		},
	},
	computed: {
		videoOptions() {
			return [
				{
					id: 'youtube',
					name: 'YouTube',
				},
				{
					id: 'vimeo',
					name: 'Vimeo',
				},
			];
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'OfferTeaserForm.scss';
</style>
